/* Core & libraries */
import React, { useEffect, useState } from 'react';
import { useTheme } from 'react-jss';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';

/* Helpers, constants, custom methods, internal libraries */
import { useAnalytics } from "../../../hooks/useAnalytics";
import { PAGE_TITLES } from "../../../constants/appConstants";
import { useHasPermission } from 'hooks/useHasPermission';
import { usePeopleService } from 'services/peopleService';

/* Components */
import TeamsGrid from './teamsGrid';
import UCButton from 'components/buttons';
import { ReactComponent as DownloadIcon } from "../../../resources/images/download-02.svg";

/* Styles */
import styles from './styles.js';

const TeamsTab = ({getTeamsList, teamsResponse, deleteTeam}) => {
  const theme = useTheme();
  const classes = styles({ theme });
  const location = useLocation();
  const { initAnalytics } = useAnalytics();
  const { checkPermission } = useHasPermission();
  const { downloadTeamsGridData } = usePeopleService();
  const totalTeams = teamsResponse?.results?.resultTotal;
  const teamsNotAvaialbleInGrid = totalTeams <= 0

  const [gridOptions, setGridOptions] = useState(() => {
    const initialPage = location.pathname.includes('/teams')
      ? new URLSearchParams(location.search).get('page') || 1
      : 1;
    return {
      page: +initialPage,
    };
  });

  useEffect(() => {
    const initUtagData = {
      channel: 'content',
      pageName: PAGE_TITLES["teams"]
    };
    initAnalytics(initUtagData, 'init call', 'view')
  }, []);

  useEffect(() => {
    getTeamsList(gridOptions);
  }, [gridOptions]);

  useEffect(() => {
    const pageFromURL = location.pathname.includes('/teams')
      ? new URLSearchParams(location.search).get('page') || 1
      : 1;
    if (+pageFromURL !== gridOptions.page) {
      setGridOptions({ ...gridOptions, page: pageFromURL });
    }
  }, [location.search]);

  const handleDeleteTeam = async (entityId) => {
    const response = await deleteTeam(entityId);
    if (response) {
      await getTeamsList(gridOptions);
      return true;
    }
    return false;
  };

  const handleDownloadTeams = () => {
    downloadTeamsGridData()
  }

  return (
    <div>
      <div className={classes.headerContainer}>
        <div className={classes.teamsTextContainer}>
          <p><FormattedMessage id="teams.grid.title" values={{totalTeams: totalTeams}}/></p>
          <span>
            <FormattedMessage id="teams.grid.description" />
          </span>
        </div>
        {checkPermission('F_TEAMS_REPORT_DOWNLOAD') && (
          <UCButton
            onClick={handleDownloadTeams}
            type="default"
            text={<FormattedMessage id="people.grids.download" />}
            className={`${classes.downloadTeamsBtn} ${teamsNotAvaialbleInGrid ? `${classes.downloadTeamsDisabledBtn}` : ``}`}
            icon={<DownloadIcon/>}
            loadingStateStyling={classes.downloadLoadingState}
            disabled={teamsNotAvaialbleInGrid}
            spinnerClassName={classes.spinner}
            spinner={{
              name: "downloadTeamsGridData",
              size: 20
            }}
          />
        )}
      </div>
      <TeamsGrid
        data={teamsResponse}
        gridOptions={gridOptions}
        setGridOptions={setGridOptions}
        deleteTeam={handleDeleteTeam}
      />
    </div>
  );
};

export default TeamsTab;
